import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AltaCostura from "../pages/altaCostura/page";
import PretAPorter from "../pages/pretAPorter/page";
import Tienda from "../pages/tienda/page";
import TiendaProductDetail from "../pages/tienda/components/TiendaProductDetail";
import Blog from "../pages/blog/page";
import BlogArticleDetail from "../pages/blog/components/BlogArticleDetail";
import Contacto from "../pages/contacto/page";
import Testimonios from "../pages/testimonios/page";
import VestidosNovia from "../pages/vestidosNovia/page";
import TrajesMedida from "../pages/trajesMedida/page";
import AdminPage from "../pages/admin/page";
import MiReserva from "../pages/miReserva/page";
import AsesoriaImagen from "../pages/asesoriaImagen/page";
import Experiencia from "../pages/experiencia/page";
import ClienteBackoffice from "../pages/clienteBackoffice/page";
import SobreNosotros from "../pages/sobreNosotros/page";
import PartnerBooking from "../pages/partnerBooking/page";
import PartnerPortal from "../pages/partnerPortal/page";
import InvoiceView from '../pages/invoice/page';
import RegistroArreglo from "../pages/registroArreglo/page";
import ReceiptView from '../pages/receipt/page';
import EstimateView from '../pages/estimate/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/partner/:slug",
    element: <PartnerBooking />,
  },
  {
    path: "/partner/:slug/portal",
    element: <PartnerPortal />,
  },
  {
    path: "/invoice/:id",
    element: <InvoiceView />,
  },
  {
    path: "/receipt/:id",
    element: <ReceiptView />,
  },
  {
    path: "/estimate/:id",
    element: <EstimateView />,
  },
  {
    path: "/alta-costura",
    element: <AltaCostura />,
  },
  {
    path: "/asesoria-imagen",
    element: <AsesoriaImagen />,
  },
  {
    path: "/experiencia",
    element: <Experiencia />,
  },
  {
    path: "/vestidos-novia",
    element: <VestidosNovia />,
  },
  {
    path: "/trajes-medida",
    element: <TrajesMedida />,
  },
  {
    path: "/pret-a-porter",
    element: <PretAPorter />,
  },
  {
    path: "/tienda",
    element: <Tienda />,
  },
  {
    path: "/tienda/:slug",
    element: <TiendaProductDetail />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticleDetail />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/testimonios",
    element: <Testimonios />,
  },
  {
    path: "/sobre-nosotros",
    element: <SobreNosotros />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/mi-reserva",
    element: <MiReserva />,
  },
  {
    path: "/mi-asesoria",
    element: <ClienteBackoffice />,
  },
  {
    path: "/registro-arreglo",
    element: <RegistroArreglo />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;